// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Dialog } from 'primereact/dialog';
// import Layout from '../../component/layout';
// import { makeRequest2 } from '../../../../utils/makeRequest';
// import { toastify } from '../../../../utils/toast';
// import { confirmManualDataURL, getEntriesAndExitsForFacility, handleAllowVisitorURL } from '../../../../utils/urls';
// import { getItem } from '../../../../utils/localStorage';
// import { getLocation } from '../../../../utils/getLocation';

// function VerifyCode() {
//     const navigate = useNavigate();
//     const [error, setError] = useState(false);
//     const [success, setSuccess] = useState(false); // Controls whether scanning is active
//     const [entries, setEntries] = useState([])
//     const [entry, setEntry] = useState('');
//     const [type, setType] = useState('');
//     const [vehicle, setVehicle] = useState({});
//     const [customer, setCustomer] = useState({});
//     const [unitName, setUnitName] = useState('');
//     const [visitLog, setVisitorLog] = useState({})
//     const [member, setMember] = useState({})
//     const [visitorDetailsVisible, setVisitorDetailsVisible] = useState(false)
//     const [uniqueCode, setUniqueCode] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [guardId, setGuardId] = useState('');
//     const [plateNumber, setPlateNumber] = useState('');
//     const [entryMethod, setEntryMethod] = useState('WALK_IN');
//     const [verificationMode, setVerificationMode] = useState('CODE');

//     const getCurrentUser = async () => {
//         try {
//             const currentUserValue = await getItem('APPUSER');

//             const currentUser = typeof currentUserValue === 'string'
//                 ? JSON.parse(currentUserValue)
//                 : currentUserValue;

//             const guardId = currentUser?.user?.userId;

//             setGuardId(guardId);
//         } catch (err) {
//             console.log(err.message);
//         }
//     };
//     const handleManualVerification = async () => {
//         setLoading(true);
//         try {
//             if (uniqueCode === '') {
//                 throw new Error('Unique Code is required.');
//             }
//             if (entry.name === '') {
//                 throw new Error('Entry Point is required.');
//             }
//             // Require plate number only for vehicles
//             if (entryMethod === 'VEHICLE' && plateNumber.trim() === '') {
//                 throw new Error('Vehicle Plate Number is required.');
//             }
//             // Get latitude and longitude from the browser's Geolocation API
//             const { latitude: lat, longitude: long } = await getLocation();
//             const value = await getItem('selectedFacilityId')
//             const response = await makeRequest2(confirmManualDataURL + '/' + value, 'POST', {
//                 uniqueCode: uniqueCode,
//                 entry: entry.name,
//                 lat: lat,
//                 long: long,
//                 entryPointId: entry._id,
//                 ...(entryMethod === 'VEHICLE' && {
//                     plateNumber: plateNumber.trim().toUpperCase()
//                 })
//             });
//             if (response.success) {
//                 toastify(response.data, 'success');
//                 setVisitorDetailsVisible(true)

//                 if (response.data.type === "Family Member") {
//                     setMember(response.data.member)
//                     setCustomer(response.data.customer)
//                     setUnitName(response.data.unitName);
//                 }
//                 else if (response.data.type === "Staff") {
//                     setMember(response.data.member)
//                     setCustomer(response.data.customer)
//                     setUnitName(response.data.unitName);
//                 }
//                 else if (response.data.type === "Vehicle") {
//                     setVehicle(response.data.vehicleData.vehicles[0]);
//                     setUnitName(response.data.unitName);
//                     setCustomer(response.data.customer)
//                 }
//                 else if (response.data.type === "Resident") {
//                     setCustomer(response.data.customer)
//                     setUnitName(response.data.unitName)
//                 }
//                 else if (response.data.type === "Visitor") {
//                     setVisitorLog(response.data.visitLog)
//                 }
//                 setType(response.data.type)
//                 setSuccess(true);
//             } else {
//                 toastify(response.error, 'error');
//                 setError(true);
//             }
//         } catch (err) {
//             toastify(err.message, 'error');
//         } finally {
//             setLoading(false);
//         }
//     };
//     const handleAllowVisitor = async () => {
//         try {
//             const value = await getItem('selectedFacilityId')

//             const response = await makeRequest2(handleAllowVisitorURL + '/' + value, 'POST', {
//                 type, vehicle, customer, visitLog, member, entry: entry.name, unitName, guardId
//             });

//             if (response.success) {
//                 setVisitorDetailsVisible(false)
//                 setUniqueCode('');
//                 toastify('Access Granted Successfully', 'success');
//                 navigate('/facility/visitor_access_management/home');
//             }
//             else {
//                 throw new Error(response.error)
//             }
//         }
//         catch (err) {
//             toastify(err.message, 'error');
//         }
//     }
//     const handlePlateVerification = async () => {
//         try {
//             alert('Plate number verification functionality coming soon!');
//         } catch (err) {
//             console.error('Plate verification error:', err);
//         }
//     };
//     const fetchEntriesAndExitsForFacility = async () => {
//         try {

//             const value = await getItem('selectedFacilityId')
//             const response = await makeRequest2(`${getEntriesAndExitsForFacility}/${value}`, 'GET', {});
//             if (response.success) {
//                 setEntries(response.data);
//             } else {
//                 throw new Error('Failed to fetch entries and exits')
//             }
//         } catch (error) {
//             toastify(error.message, 'error');
//         }
//     };

//     const getCurrentAccessPoint = async () => {
//         try {
//             const value = await getItem('selectedEntryPoint');
//             if (value) {
//                 let data;
//                 if (typeof value === 'string') {
//                     try {
//                         data = JSON.parse(value);
//                     } catch (err) {
//                         console.error("Error parsing selectedEntryPoint:", err.message);
//                         return; // Exit if parsing fails
//                     }
//                 } else {
//                     data = value; // Already an object
//                 }
//                 setEntry(data);
//             }
//         } catch (err) {
//             console.log(err.message);
//         }
//     };

//     useEffect(() => {
//         getCurrentUser();
//         fetchEntriesAndExitsForFacility();
//         getCurrentAccessPoint()
//     }, []);

//     return (
//         <Layout>
//             <div className="page-header">
//                 <div className="page-block">
//                     <div className="row align-items-center">
//                         <div className="col-md-12">
//                             <ul className="breadcrumb">
//                                 <li className="breadcrumb-item">
//                                     <Link to={"#"}>Visitor & Access Management</Link>
//                                 </li>
//                                 <li className="breadcrumb-item">
//                                     <Link to={"#"}>Verify Code</Link>
//                                 </li>
//                             </ul>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="row">
//                 <div className="col-sm-12">
//                     <div className="row">
//                         <div className="col-sm-12">
//                             <div className="card">
//                                 <div className="card-header">
//                                     <h5>Verify Code</h5>
//                                 </div>

//                                 <div className="card-body">
//                                     <div className="row">
//                                         <div className="col-lg-12 col-xxl-12">
//                                             <div className="card">
//                                                 <div className="card-body position-relative">

//                                                     {/* Verification Mode Selection */}
//                                                     <div className="row">
//                                                         <div className="col-md-4">
//                                                             <div className="mb-4">
//                                                                 <label htmlFor="verificationMode" className="form-label">
//                                                                     Verification Mode
//                                                                 </label>

//                                                                 <select
//                                                                     id="verificationMode"
//                                                                     className="form-control"
//                                                                     value={verificationMode}
//                                                                     onChange={(e) => setVerificationMode(e.target.value)}
//                                                                 >
//                                                                     <option value="CODE">Code Verification</option>
//                                                                     <option value="PLATE_ONLY">Plate Number Only</option>
//                                                                 </select>

//                                                                 <small className="text-muted">
//                                                                     Choose how you want to verify the visitor.
//                                                                 </small>
//                                                             </div>
//                                                         </div>
//                                                     </div>

//                                                     {/* CODE VERIFICATION - EXISTING WORKFLOW */}
//                                                     {verificationMode === 'CODE' && (
//                                                         <>
//                                                             <div className="row">
//                                                                 {/* Entry Type Selection */}
//                                                                 <div className="col-md-4">
//                                                                     <div className="mb-3">
//                                                                         <label htmlFor="entryMethod" className="form-label">
//                                                                             Entry Type <span className="text-danger">*</span>
//                                                                         </label>

//                                                                         <select
//                                                                             id="entryMethod"
//                                                                             className="form-control"
//                                                                             value={entryMethod}
//                                                                             onChange={(e) => setEntryMethod(e.target.value)}
//                                                                         >
//                                                                             <option value="WALK_IN">Walk-in</option>
//                                                                             <option value="VEHICLE">Vehicle</option>
//                                                                         </select>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className="row">
//                                                                 {/* Customer Code */}
//                                                                 <div className="col-md-4">
//                                                                     <div className="mb-3">
//                                                                         <label htmlFor="uniqueCode" className="form-label">
//                                                                             Enter Code <span className="text-danger">*</span>
//                                                                         </label>

//                                                                         <input
//                                                                             id="uniqueCode"
//                                                                             type="number"
//                                                                             className="form-control"
//                                                                             value={uniqueCode}
//                                                                             onChange={(e) => setUniqueCode(e.target.value)}
//                                                                             placeholder="Enter customer code"
//                                                                         />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             {/* Vehicle Plate Number */}
//                                                             {entryMethod === 'VEHICLE' && (
//                                                                 <div className="row">
//                                                                     <div className="col-md-4">
//                                                                         <div className="mb-3">
//                                                                             <label htmlFor="plateNumber" className="form-label">
//                                                                                 Vehicle Plate Number{' '}
//                                                                                 <span className="text-danger">*</span>
//                                                                             </label>

//                                                                             <input
//                                                                                 id="plateNumber"
//                                                                                 type="text"
//                                                                                 className="form-control"
//                                                                                 value={plateNumber}
//                                                                                 onChange={(e) =>
//                                                                                     setPlateNumber(e.target.value.toUpperCase())
//                                                                                 }
//                                                                                 placeholder="e.g. KDA 123A"
//                                                                             />
//                                                                         </div>
//                                                                     </div>
//                                                                 </div>
//                                                             )}

//                                                             {/* Existing Verification Button */}
//                                                             <button
//                                                                 type="button"
//                                                                 className="btn btn-primary mt-2"
//                                                                 onClick={handleManualVerification}
//                                                                 disabled={loading}
//                                                             >
//                                                                 {loading ? 'Verifying, please wait...' : 'Verify'}
//                                                             </button>
//                                                         </>
//                                                     )}

//                                                     {/* PLATE NUMBER ONLY VERIFICATION */}
//                                                     {verificationMode === 'PLATE_ONLY' && (
//                                                         <>
//                                                             <div className="row">
//                                                                 <div className="col-md-4">
//                                                                     <div className="mb-3">
//                                                                         <label htmlFor="plateNumberOnly" className="form-label">
//                                                                             Vehicle Plate Number{' '}
//                                                                             <span className="text-danger">*</span>
//                                                                         </label>

//                                                                         <input
//                                                                             id="plateNumberOnly"
//                                                                             type="text"
//                                                                             className="form-control"
//                                                                             value={plateNumber}
//                                                                             onChange={(e) =>
//                                                                                 setPlateNumber(e.target.value.toUpperCase())
//                                                                             }
//                                                                             placeholder="e.g. KDA 123A"
//                                                                         />

//                                                                         <small className="text-muted">
//                                                                             Enter the vehicle registration number to verify
//                                                                             without a customer code.
//                                                                         </small>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <button
//                                                                 type="button"
//                                                                 className="btn btn-primary mt-2"
//                                                                 onClick={handlePlateVerification}
//                                                                 disabled={loading}
//                                                             >
//                                                                 {loading ? 'Verifying, please wait...' : 'Verify Plate Number'}
//                                                             </button>
//                                                         </>
//                                                     )}

//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                 </div>


//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <Dialog header={type} visible={visitorDetailsVisible} style={{ width: '50vw' }} onHide={() => { if (!visitorDetailsVisible) return; setVisitorDetailsVisible(false); }}>

//                 <div className="row">
//                     {
//                         type === 'Family Member' && <div className="card">
//                             <div className="card-body" style={{ paddingTop: 50 }}>
//                                 <p>House Number: <strong>{unitName}</strong></p>
//                             </div>
//                         </div>
//                     }
//                     {
//                         type === 'Staff' && <div className="card">
//                             <div className="card-body" style={{ paddingTop: 50 }}>
//                                 <p>House Number: <strong>{unitName}</strong></p>
//                             </div>
//                         </div>
//                     }
//                     {
//                         type === 'Vehicle' && <div className="card">
//                             <div className="card-body" style={{ paddingTop: 50 }}>
//                                 <p>House Number: <strong>{unitName}</strong></p>
//                             </div>
//                         </div>
//                     }
//                     {
//                         type === 'Resident' && <div className="card">
//                             <div className="card-body" style={{ paddingTop: 50 }}>
//                                 <p>House Number: <strong>{unitName}</strong></p>
//                             </div>
//                         </div>
//                     }
//                     {
//                         type === 'Visitor' && <div className="card">
//                             <div className="card-body" style={{ paddingTop: 50 }}>
//                                 <p>House Number: <strong>{visitLog.houseNumber}</strong></p>
//                             </div>
//                         </div>
//                     }

//                     <button className="btn btn-primary" onClick={handleAllowVisitor}>Allow Visit</button>

//                 </div>

//             </Dialog>
//         </Layout>
//     );
// }

// export default VerifyCode;



import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import Layout from '../../component/layout';
import { makeRequest2 } from '../../../../utils/makeRequest';
import { toastify } from '../../../../utils/toast';
import { confirmManualDataURL, getEntriesAndExitsForFacility, handleAllowVisitorURL } from '../../../../utils/urls';
import { getItem } from '../../../../utils/localStorage';
import { getLocation } from '../../../../utils/getLocation';

function VerifyCode() {
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false); // Controls whether scanning is active
    const [entries, setEntries] = useState([])
    const [entry, setEntry] = useState('');
    const [type, setType] = useState('');
    const [vehicle, setVehicle] = useState({});
    const [customer, setCustomer] = useState({});
    const [unitName, setUnitName] = useState('');
    const [visitLog, setVisitorLog] = useState({})
    const [member, setMember] = useState({})
    const [visitorDetailsVisible, setVisitorDetailsVisible] = useState(false)
    const [uniqueCode, setUniqueCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [guardId, setGuardId] = useState('');
    const [plateNumber, setPlateNumber] = useState('');
    const [entryMethod, setEntryMethod] = useState('WALK_IN');
    const [verificationMode, setVerificationMode] = useState('CODE');
    // CHANGE: state to control whether new display features are shown
    const [showNewFeatures, setShowNewFeatures] = useState(false);

    // CHANGE: facility ID from env that should see the new display features
    const ENHANCED_FACILITY_ID = process.env.REACT_APP_ENHANCED_VERIFY_FACILITY_ID;

    // CHANGE: check if current facility matches the enhanced facility ID
    const checkFacilityFeatureFlag = async () => {
        try {
            const selectedFacilityId = await getItem('selectedFacilityId');
            if (!selectedFacilityId || !ENHANCED_FACILITY_ID) {
                setShowNewFeatures(false);
                return;
            }
            let facilityId = selectedFacilityId;
            if (typeof facilityId === 'string') {
                try {
                    const parsed = JSON.parse(facilityId);
                    facilityId = typeof parsed === 'string'
                        ? parsed
                        : (parsed?._id || parsed?.id || facilityId);
                } catch {
                    // plain string, keep as-is
                }
            } else if (typeof facilityId === 'object') {
                facilityId = facilityId?._id || facilityId?.id;
            }
            setShowNewFeatures(String(facilityId) === String(ENHANCED_FACILITY_ID));
        } catch (err) {
            console.log(err.message);
            setShowNewFeatures(false);
        }
    };

    const getCurrentUser = async () => {
        try {
            const currentUserValue = await getItem('APPUSER');
            const currentUser = typeof currentUserValue === 'string'
                ? JSON.parse(currentUserValue)
                : currentUserValue;
            const guardId = currentUser?.user?.userId;
            setGuardId(guardId);
        } catch (err) {
            console.log(err.message);
        }
    };

    const handleManualVerification = async () => {
        setLoading(true);
        try {
            if (uniqueCode === '') {
                throw new Error('Unique Code is required.');
            }
            if (entry.name === '') {
                throw new Error('Entry Point is required.');
            }
            if (entryMethod === 'VEHICLE' && plateNumber.trim() === '') {
                throw new Error('Vehicle Plate Number is required.');
            }
            const { latitude: lat, longitude: long } = await getLocation();
            const value = await getItem('selectedFacilityId')
            const response = await makeRequest2(confirmManualDataURL + '/' + value, 'POST', {
                uniqueCode: uniqueCode,
                entry: entry.name,
                lat: lat,
                long: long,
                entryPointId: entry._id,
                ...(entryMethod === 'VEHICLE' && {
                    plateNumber: plateNumber.trim().toUpperCase()
                })
            });
            if (response.success) {
                toastify(response.data, 'success');
                setVisitorDetailsVisible(true)

                if (response.data.type === "Family Member") {
                    setMember(response.data.member)
                    setCustomer(response.data.customer)
                    setUnitName(response.data.unitName);
                }
                else if (response.data.type === "Staff") {
                    setMember(response.data.member)
                    setCustomer(response.data.customer)
                    setUnitName(response.data.unitName);
                }
                else if (response.data.type === "Vehicle") {
                    setVehicle(response.data.vehicleData.vehicles[0]);
                    setUnitName(response.data.unitName);
                    setCustomer(response.data.customer)
                }
                else if (response.data.type === "Resident") {
                    setCustomer(response.data.customer)
                    setUnitName(response.data.unitName)
                }
                else if (response.data.type === "Visitor") {
                    setVisitorLog(response.data.visitLog)
                }
                setType(response.data.type)
                setSuccess(true);
            } else {
                toastify(response.error, 'error');
                setError(true);
            }
        } catch (err) {
            toastify(err.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleAllowVisitor = async () => {
        try {
            const value = await getItem('selectedFacilityId')
            const response = await makeRequest2(handleAllowVisitorURL + '/' + value, 'POST', {
                type, vehicle, customer, visitLog, member, entry: entry.name, unitName, guardId
            });
            if (response.success) {
                setVisitorDetailsVisible(false)
                setUniqueCode('');
                toastify('Access Granted Successfully', 'success');
                navigate('/facility/visitor_access_management/home');
            }
            else {
                throw new Error(response.error)
            }
        }
        catch (err) {
            toastify(err.message, 'error');
        }
    }

    const handlePlateVerification = async () => {
        try {
            alert('Plate number verification functionality coming soon!');
        } catch (err) {
            console.error('Plate verification error:', err);
        }
    };

    const fetchEntriesAndExitsForFacility = async () => {
        try {
            const value = await getItem('selectedFacilityId')
            const response = await makeRequest2(`${getEntriesAndExitsForFacility}/${value}`, 'GET', {});
            if (response.success) {
                setEntries(response.data);
            } else {
                throw new Error('Failed to fetch entries and exits')
            }
        } catch (error) {
            toastify(error.message, 'error');
        }
    };

    const getCurrentAccessPoint = async () => {
        try {
            const value = await getItem('selectedEntryPoint');
            if (value) {
                let data;
                if (typeof value === 'string') {
                    try {
                        data = JSON.parse(value);
                    } catch (err) {
                        console.error("Error parsing selectedEntryPoint:", err.message);
                        return; // Exit if parsing fails
                    }
                } else {
                    data = value; // Already an object
                }
                setEntry(data);
            }
        } catch (err) {
            console.log(err.message);
        }
    };

    useEffect(() => {
        getCurrentUser();
        fetchEntriesAndExitsForFacility();
        getCurrentAccessPoint();
        // CHANGE: run the facility feature-flag check on mount
        checkFacilityFeatureFlag();
    }, []);

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Visitor & Access Management</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"#"}>Verify Code</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Verify Code</h5>
                                </div>

                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-lg-12 col-xxl-12">
                                            <div className="card">
                                                <div className="card-body position-relative">

                                                    {/* ========================================================= */}
                                                    {/* CHANGE: NEW DISPLAY BLOCK — only rendered when      */}
                                                    {/* current facility matches REACT_APP_ENHANCED_VERIFY_FACILITY_ID */}
                                                    {/* ========================================================= */}
                                                    {showNewFeatures && (
                                                        <>
                                                            {/* Verification Mode Selection */}
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <div className="mb-4">
                                                                        <label htmlFor="verificationMode" className="form-label">
                                                                            Verification Mode
                                                                        </label>

                                                                        <select
                                                                            id="verificationMode"
                                                                            className="form-control"
                                                                            value={verificationMode}
                                                                            onChange={(e) => setVerificationMode(e.target.value)}
                                                                        >
                                                                            <option value="CODE">Code Verification</option>
                                                                            <option value="PLATE_ONLY">Plate Number Only</option>
                                                                        </select>

                                                                        <small className="text-muted">
                                                                            Choose how you want to verify the visitor.
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* CODE VERIFICATION - EXISTING WORKFLOW */}
                                                            {verificationMode === 'CODE' && (
                                                                <>
                                                                    <div className="row">
                                                                        {/* Entry Type Selection */}
                                                                        <div className="col-md-4">
                                                                            <div className="mb-3">
                                                                                <label htmlFor="entryMethod" className="form-label">
                                                                                    Entry Type <span className="text-danger">*</span>
                                                                                </label>

                                                                                <select
                                                                                    id="entryMethod"
                                                                                    className="form-control"
                                                                                    value={entryMethod}
                                                                                    onChange={(e) => setEntryMethod(e.target.value)}
                                                                                >
                                                                                    <option value="WALK_IN">Walk-in</option>
                                                                                    <option value="VEHICLE">Vehicle</option>
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row">
                                                                        {/* Customer Code */}
                                                                        <div className="col-md-4">
                                                                            <div className="mb-3">
                                                                                <label htmlFor="uniqueCode" className="form-label">
                                                                                    Enter Code <span className="text-danger">*</span>
                                                                                </label>

                                                                                <input
                                                                                    id="uniqueCode"
                                                                                    type="number"
                                                                                    className="form-control"
                                                                                    value={uniqueCode}
                                                                                    onChange={(e) => setUniqueCode(e.target.value)}
                                                                                    placeholder="Enter customer code"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* Vehicle Plate Number */}
                                                                    {entryMethod === 'VEHICLE' && (
                                                                        <div className="row">
                                                                            <div className="col-md-4">
                                                                                <div className="mb-3">
                                                                                    <label htmlFor="plateNumber" className="form-label">
                                                                                        Vehicle Plate Number{' '}
                                                                                        <span className="text-danger">*</span>
                                                                                    </label>

                                                                                    <input
                                                                                        id="plateNumber"
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={plateNumber}
                                                                                        onChange={(e) =>
                                                                                            setPlateNumber(e.target.value.toUpperCase())
                                                                                        }
                                                                                        placeholder="e.g. KDA 123A"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {/* Existing Verification Button */}
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary mt-2"
                                                                        onClick={handleManualVerification}
                                                                        disabled={loading}
                                                                    >
                                                                        {loading ? 'Verifying, please wait...' : 'Verify'}
                                                                    </button>
                                                                </>
                                                            )}

                                                            {/* PLATE NUMBER ONLY VERIFICATION */}
                                                            {verificationMode === 'PLATE_ONLY' && (
                                                                <>
                                                                    <div className="row">
                                                                        <div className="col-md-4">
                                                                            <div className="mb-3">
                                                                                <label htmlFor="plateNumberOnly" className="form-label">
                                                                                    Vehicle Plate Number{' '}
                                                                                    <span className="text-danger">*</span>
                                                                                </label>

                                                                                <input
                                                                                    id="plateNumberOnly"
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    value={plateNumber}
                                                                                    onChange={(e) =>
                                                                                        setPlateNumber(e.target.value.toUpperCase())
                                                                                    }
                                                                                    placeholder="e.g. KDA 123A"
                                                                                />

                                                                                <small className="text-muted">
                                                                                    Enter the vehicle registration number to verify
                                                                                    without a customer code.
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary mt-2"
                                                                        onClick={handlePlateVerification}
                                                                        disabled={loading}
                                                                    >
                                                                        {loading ? 'Verifying, please wait...' : 'Verify Plate Number'}
                                                                    </button>
                                                                </>
                                                            )}
                                                        </>
                                                    )}

                                                    {/* ========================================================= */}
                                                    {/* CHANGE: ORIGINAL DISPLAY — rendered only when the   */}
                                                    {/* facility does NOT match the enhanced facility ID      */}
                                                    {/* ========================================================= */}
                                                    {!showNewFeatures && (
                                                        <>
                                                            <div className="col-sm-4">
                                                                <div className="mb-3">
                                                                    {/* original commented-out entry point block preserved */}
                                                                </div>
                                                            </div>

                                                            {/* Manual Input Field for Customer Number */}
                                                            <div className="col-sm-4">
                                                                <div className="mb-3">
                                                                    <label>Enter Code</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control mt-2"
                                                                        value={uniqueCode}
                                                                        onChange={(e) => setUniqueCode(e.target.value)}
                                                                    />
                                                                </div>
                                                                <button className="btn btn-primary mt-2" onClick={handleManualVerification} disabled={loading}>
                                                                    {loading ? 'Verifying, please wait...' : 'Verify'}
                                                                </button>
                                                            </div>
                                                        </>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog header={type} visible={visitorDetailsVisible} style={{ width: '50vw' }} onHide={() => { if (!visitorDetailsVisible) return; setVisitorDetailsVisible(false); }}>

                <div className="row">
                    {
                        type === 'Family Member' && <div className="card">
                            <div className="card-body" style={{ paddingTop: 50 }}>
                                <p>House Number: <strong>{unitName}</strong></p>
                            </div>
                        </div>
                    }
                    {
                        type === 'Staff' && <div className="card">
                            <div className="card-body" style={{ paddingTop: 50 }}>
                                <p>House Number: <strong>{unitName}</strong></p>
                            </div>
                        </div>
                    }
                    {
                        type === 'Vehicle' && <div className="card">
                            <div className="card-body" style={{ paddingTop: 50 }}>
                                <p>House Number: <strong>{unitName}</strong></p>
                            </div>
                        </div>
                    }
                    {
                        type === 'Resident' && <div className="card">
                            <div className="card-body" style={{ paddingTop: 50 }}>
                                <p>House Number: <strong>{unitName}</strong></p>
                            </div>
                        </div>
                    }
                    {
                        type === 'Visitor' && <div className="card">
                            <div className="card-body" style={{ paddingTop: 50 }}>
                                <p>House Number: <strong>{visitLog.houseNumber}</strong></p>
                            </div>
                        </div>
                    }

                    <button className="btn btn-primary" onClick={handleAllowVisitor}>Allow Visit</button>

                </div>

            </Dialog>
        </Layout>
    );
}

export default VerifyCode;
